import { Component, inject, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AufgabenTyp, AufgabeVersandTaetigkeit } from '@schir-int-client/aufgabe-shared';
import { CreateAufgabeFormService } from '@schir-int-client/aufgabe';
import { VorlageResource } from '@schir-int-client/vorlage-shared';
import { VorlageService } from '../../../../../vorlage-shared/src/lib/vorlage.service';
import { KorrespondenzValidationMessages } from '../../korrespondenz.messages';
import { getIdNumber } from '../../../../../test-helpers/src/lib/resource-helper';

@Component({
	selector: 'schir-int-client-aufgabe-anschreiben-editor',
	templateUrl: 'aufgabe-anschreiben-editor.component.html',
	styleUrl: 'aufgabe-anschreiben-editor.component.scss',
	standalone: false,
})
export class AufgabeAnschreibenEditorComponent {
	private readonly formService = inject(CreateAufgabeFormService);

	readonly vorlagen = input.required<VorlageResource[]>();
	readonly excludeEingetragenerEigentuemer = input(true);
	readonly multipleVorlagen = input.required<boolean>();

	protected get formGroup() {
		return this.formService.form.controls.ANSCHREIBEN;
	}

	protected get bodyControls() {
		return this.formGroup.controls.body.controls;
	}

	getVorlageId(vorlage: VorlageResource): number {
		return getIdNumber(vorlage);
	}

	public addVorlageSelect() {
		this.bodyControls.vorlageIds.push(new FormControl(null));
	}

	protected removeVorlageSelect(index: number) {
		this.bodyControls.vorlageIds.removeAt(index);
	}

	protected readonly VorlageService = VorlageService;
	protected readonly CreateAufgabeFormService = CreateAufgabeFormService;
	protected readonly KorrespondenzValidationMessages = KorrespondenzValidationMessages;
	protected readonly AufgabeVersandTaetigkeit = AufgabeVersandTaetigkeit;
	protected readonly AufgabenTyp = AufgabenTyp;
}
